// src/components/gTagUtils.js

export function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof url !== "undefined") {
      window.location = url;
    }
  };

  // Ignore ESLint warning for gtag
  /* global gtag */

  if (typeof gtag !== "undefined") {
    gtag("event", "conversion", {
      send_to: "AW-16693317711/JxrdCIHcutAZEM-g_5c-",
      value: 1.0,
      currency: "INR",
      event_callback: callback,
    });
  }
  return false;
}
